var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCupper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M819.191 750.916v68.267c0 20.48-13.653 34.133-34.133 34.133s-34.133-13.653-34.133-34.133v-68.267c0-58.027-44.373-102.4-102.4-102.4h-273.067c-58.027 0-102.4 44.373-102.4 102.4v68.267c0 20.48-13.653 34.133-34.133 34.133s-34.133-13.653-34.133-34.133v-68.267c0-95.573 75.093-170.667 170.667-170.667h273.067c95.573 0 170.667 75.093 170.667 170.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 170.667c-95.573 0-170.667 75.093-170.667 170.667s75.093 170.667 170.667 170.667c95.573 0 170.667-75.093 170.667-170.667s-75.093-170.667-170.667-170.667zM511.983 443.716c-58.027 0-102.4-44.373-102.4-102.4s44.373-102.4 102.4-102.4c58.027 0 102.4 44.373 102.4 102.4s-44.373 102.4-102.4 102.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCupper);
export default __webpack_public_path__ + "static/media/icon-cupper.80678d55e4a286c353d6f3c841ac7faf.svg";
export { ForwardRef as ReactComponent };